export default {
    unit_type_events_list_title: "Lista eventos por tipo de unidad",
    unit_type_events_list_name: "Nombre",
    unit_type_events_list_status: "Estado",
    unit_type_events_list_active: "Activo",
    unit_type_events_list_inactive: "Inactivo",
    unit_type_events_list_diagnostic: "Diagnóstico",
    unit_type_events_list_tab_general: "General",
    unit_type_events_list_tab_unit_type_event: "Typo de Evento de Unidad",
    unit_type_events_list_raw_event: "Evento sin procesar",
    unit_type_events_list_manufaturers: "Fabricantes",
}